import PropTypes from 'prop-types';
import { connectLean } from 'lean-redux';

const VideoProgressCallbacks = (props) => {
  const {
    userData,
    render,
    withWatchedVideo,
    updateResourceWatchedStatus,
    onStoreDailyProgress,
  } = props;
  const { isStudent, isTeacher, isImpersonating } = userData;

  const canStoreProgress = isTeacher || isStudent;

  const getUpdateWatchedStatusFunc = () =>
    (isStudent &&
      !isImpersonating &&
      !withWatchedVideo &&
      updateResourceWatchedStatus) ||
    null;

  const onPlay = (progressInfo) => {
    canStoreProgress &&
      onStoreDailyProgress(
        progressInfo || {},
        false,
        getUpdateWatchedStatusFunc(),
      );
  };

  const onEnd = (progressInfo) => {
    canStoreProgress &&
      onStoreDailyProgress(
        progressInfo || {},
        false,
        getUpdateWatchedStatusFunc(),
      );
  };

  const onPlaying = (_, newSecondsHaveElapsed, progressInfo) => {
    const sendEvent = newSecondsHaveElapsed && canStoreProgress;
    if (sendEvent) {
      //notify server about progress
      onStoreDailyProgress(
        progressInfo || {},
        false,
        getUpdateWatchedStatusFunc(),
      );
    }
  };

  const onPause = (progressInfo) => {
    canStoreProgress &&
      onStoreDailyProgress(
        progressInfo || {},
        false,
        getUpdateWatchedStatusFunc(),
      );
  };

  const onClose = (progressInfo) => {
    canStoreProgress &&
      onStoreDailyProgress(
        progressInfo || {},
        true,
        getUpdateWatchedStatusFunc(),
      );
  };

  const eventCallbacks = {
    onPlay,
    onEnd,
    onPlaying,
    onPause,
    onClose,
  };

  return render({
    eventCallbacks,
  });
};

VideoProgressCallbacks.propTypes = {
  render: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
};

export default connectLean({
  mapState({ withWatchedVideo }) {
    return {
      withWatchedVideo,
    };
  },
  updateResourceWatchedStatus(isWatched, isStarted) {
    this.setState((previousState) => ({
      ...previousState,
      withWatchedVideo: isWatched,
      isStarted,
    }));
  },
})(VideoProgressCallbacks);
